import { Phone } from 'app/interfaces/customVariablesInterfaces';
import { IFgtsPeriods } from '../FgtsStep/interfaces';

interface ConsignedEmployer {
  code?: number;
  document?: string;
  name?: string;
}

export interface ConsignedEmployee {
  code?: number;
  document?: string;
  name?: string;
}

interface ConsignedProductStatus {
  code?: string;
  description?: string;
}

interface ConsignedAuthorization {
  authorized?: boolean;
  type_product?: TypeProduct;
  validity?: string;
}

interface ConsignedPortability {
  authorized: boolean;
  available_balance: number;
  type_product?: string;
  validity?: string;
  contract_port?: {
    contract_id?: string;
    document?: string;
    name_consignee?: string;
  };
}
export interface IConsignedProduct {
  balance_check_id?: string;
  rubric?: ConsignedProductStatus;
  agreement?: string;
  available_balance?: number;
  authorization?: {
    details?: ConsignedAuthorization[];
    portability?: ConsignedPortability[];
  };
}

export interface IConsigneeConfig {
  agency?: string;
  consignee?: string;
}

interface ConsignedDescription {
  code?: number;
  description?: string;
}

interface AlertConsigned {
  alert_type?: {
    description?: string;
    code?: number;
  };
  absence_date?: string; // Afastamento
  absence_end_date?: string; // Afastamento
  absence_reason_code?: string; // Afastamento Razão
  reference_date?: string;
  event_id?: string;
  termination_reason_code?: string;
  prior_notice_date?: string; // Aviso prévio começo
  prior_notice_end_date?: string; // Aviso prévio fim
  termination_date?: string; // Data desligamento
}

export interface LegacyConsigned {
  financial_institution_code?: number;
  contract?: string;
  contract_start_date?: string;
  contract_end_date?: string;
  installment_amount?: number;
  loan_amount?: number;
  net_amount?: number;
  update_date_time?: string;
  interest_tax?: number;
  monthly_cet?: number;
  installment_quantity?: number;
  paid_installments_quantity?: number;
  debtor_balance_amount?: number;
  contract_type?: {
    description?: string;
    code?: number;
  };
}

export interface IConsigned {
  balance_check_date: string;
  config?: IConsigneeConfig;
  employee?: ConsignedEmployee;
  employer?: ConsignedEmployer;
  products?: IConsignedProduct[];
  meta_data: {
    // CT
    absence_date?: string; // Afastamento
    absence_end_date?: string; // Afastamento
    absence_reason_code?: string; // Afastamento Razão
    admission_date?: string;
    alerts?: AlertConsigned[];
    amount_loans_assets_suspended?: string;
    base_margin_value?: string;
    birth_date?: string;
    economic_activity_code?: ConsignedDescription;
    employer_activity_start_date?: string;
    gender?: ConsignedDescription;
    job_code?: ConsignedDescription; // CBO
    legacy_loans?: LegacyConsigned[];
    mother_name?: string;
    nationality_country?: ConsignedDescription;
    politically_exposed_person?: ConsignedDescription;
    prior_notice_date?: string; // Aviso prévio começo
    prior_notice_end_date?: string; // Aviso prévio fim
    termination_date?: string; // Data desligamento
    termination_reason_code?: string; // Motivo do desligamento, só código
    total_earnings?: string;
    unauthorization_reason?: ConsignedDescription;
    worker_category_code?: string; // Cód categoria trabalhador

    // FGTS
    periods?: IFgtsPeriods[];
    has_disregarded_balance?: boolean;

    // SIAPE
    functional_status_code?: string; // "EST02",
    functional_status_description?: string; // "APOSENTADO",
    link_type_code?: string;
    link_type_description?: string; // "Servidor"
    classification_code?: string; // "S",
    classification_description?: string; // "Estável",
    home_account?: string; // "00000003927**",
    home_agency?: string;
    home_bank?: string;
    paying_unit_code?: string; // "26239000000852",
    paying_unit_state?: string; // "PA",
    pension_due_date?: string;
    pension_type_code?: string;
    pension_type_description?: string;
  };
}

export interface IConsignedList {
  links: IConsigned[];
  message?: string;
  id?: string; // balance_check_id
}

export enum GuaranteeStatus {
  WAITING_ANNOTATION_REGISTRATION = 'WAITING_ANNOTATION_REGISTRATION',
  WAITING_ANNOTATION_CONFIRMATION = 'WAITING_ANNOTATION_CONFIRMATION',
  ERROR = 'ERROR',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
}

export enum ConsigneeOrganType {
  CT = 'CT',
  SIAPE = 'SIAPE',
  FGTS = 'FGTS',
  INSS = 'INSS',
}

export enum TypeProduct {
  LOAN = 'LOAN',
  CARD_CREDIT = 'CARD_CREDIT',
  CARD_BENEFICIARY = 'CARD_BENEFICIARY',
  MONTHLY_DESC = 'MONTHLY_DESC',
  SYNDICAL_DESC = 'SYNDICAL_DESC',
  PORTABILITY = 'PORTABILITY',
}

export enum ConsigneeStatus {
  WAITING_SIGNATURE = 'WAITING_SIGNATURE',
  AUTHORIZED = 'AUTHORIZED',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export const enum ConsignedAuthorizationTypes {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
}

export interface ConsigneeAuthorizationPayload {
  name: string;
  taxpayer_id: string;
  mode: ConsignedAuthorizationTypes;
  email: string;
  product_id: string;
  phone: Phone;
}
